// Whether the person asked for reduced motion (`prefers-reduced-motion`), kept
// current across the session. The voice bar's level meter stands still then
// (BUILD 2 WP2-8 step 5): the scrolling waveform is motion, while the live
// text and the microphone indicator still say that voice mode hears.
import { useSyncExternalStore } from 'react';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

const query = (): MediaQueryList | null =>
  typeof globalThis.matchMedia === 'function' ? globalThis.matchMedia(REDUCED_MOTION_QUERY) : null;

function subscribe(onChange: () => void): () => void {
  const list = query();
  list?.addEventListener?.('change', onChange);
  return () => list?.removeEventListener?.('change', onChange);
}

export const prefersReducedMotion = (): boolean => query()?.matches === true;

export const useReducedMotion = (): boolean =>
  useSyncExternalStore(subscribe, prefersReducedMotion, () => false);
